/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_SignalInputs */

const cs_enum_signal = /** @type {(inputs: Enum_SignalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signal`)
};

const en_enum_signal = /** @type {(inputs: Enum_SignalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signal`)
};

/**
* | output |
* | --- |
* | "Signal" |
*
* @param {Enum_SignalInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_signal = /** @type {((inputs?: Enum_SignalInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_SignalInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_signal(inputs)
	return cs_enum_signal(inputs)
});